import React from "react";
import Breadcrumbs from "../../../../../../components/BreadCrumbs";
import { ROUTE_PATHS } from "../../../../../../utils/RoutesPaths";
import { useSelector } from "react-redux";
import { generatePath, useHistory } from "react-router-dom";
import messages from "../../../../../../assets/locale/messages";
import CompanyHeader from "../../../../../../components/Company/CompanyViewDetails/Header/CompanyHeader";
import PropTypes from "prop-types";

import "./_CompanyDetailsHeader.scss";

const breadcrumbItem = PropTypes.shape({
  path: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
});

/** Companies list → company name; optional `extraBreadcrumbs` after that (company name becomes a link when extras exist).
 * `leadingBreadcrumbs` overrides the crumb(s) before the company name — e.g.
 * "Profile Edit Requests → Companies" when arriving from that list instead
 * of just "Companies". */
const CompanyDetailsHeader = ({
  companyDetails,
  id: idProp,
  extraBreadcrumbs,
  leadingBreadcrumbs,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { companiesList: cl } = messages[lang];
  const history = useHistory();

  const companyId = idProp ?? companyDetails?.id;
  const companyProfilePath =
    companyId != null
      ? ROUTE_PATHS.companiesListCompanyDetails.replace(
          ":id",
          String(companyId),
        )
      : undefined;

  const handleEditProfile = () => {
    if (companyId != null) {
      history.push(
        generatePath(ROUTE_PATHS.companiesListCompanyEdit, {
          id: companyId,
        }),
      );
    }
  };

  const breadcrumbName =
    lang === "en"
      ? companyDetails?.name_en ?? companyDetails?.name
      : companyDetails?.name_ar ??
        companyDetails?.name_en ??
        companyDetails?.name;


  return (
    <div className="mt-3">
      <Breadcrumbs
        list={[
          ...(leadingBreadcrumbs || [
            { path: ROUTE_PATHS.companiesList, label: cl.listBreadcrumb },
          ]),
          {
            path:
              extraBreadcrumbs?.length > 0 && companyProfilePath
                ? companyProfilePath
                : "",
            label: breadcrumbName || "—",
          },
          ...(Array.isArray(extraBreadcrumbs) ? extraBreadcrumbs : []),
        ]}
        BreadCrumbHasBackIcon={false}
      />
      <div className="company-details-header-view">
        <CompanyHeader
          company={companyDetails}
          hasJoinedDate
          onEditProfile={handleEditProfile}
        />
      </div>
    </div>
  );
};

export default CompanyDetailsHeader;

CompanyDetailsHeader.propTypes = {
  companyDetails: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  extraBreadcrumbs: PropTypes.arrayOf(breadcrumbItem),
  leadingBreadcrumbs: PropTypes.arrayOf(breadcrumbItem),
};

CompanyDetailsHeader.defaultProps = {
  companyDetails: undefined,
  id: undefined,
  extraBreadcrumbs: [],
  leadingBreadcrumbs: undefined,
};
